import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { TreeView, TreeItem } from '@mui/lab';
import { Checkbox, FormControlLabel, Grid, Stack } from '@mui/material';
import Box from '@mui/material/Box';
import { styled } from '@mui/styles';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { IoFilterSharp } from 'react-icons/io5';
import { amplitude } from 'wisestep-api';
import {
  WsButton,
  WsColors,
  WsDrawer,
  WsTypography,
  WsTypoVariants,
  WsTypoColors,
  WsRadioGroup,
} from 'wisestep-base';

import { useStatusActionPipelineContextNew, useWorkspaceContext } from '../../../../src/context';
import { ActivateFeature } from '../../../components/ActivateFeature';
import { candidateInteractionMessagingPipelines } from '../../../features/crmSettings/ManageRecruiterActions/helper';
// import { actionFilterPipelineStore } from '../../../utils/ActionFiltersPiplineStore';
import ActionFiltersFormProps from '../models/ActionFiltersFormProps';

export interface ActionFilterPropsFiltersProps {
  onApplyFilters?: (formProps: ActionFiltersFormProps) => void;
  filterClose?: () => void;
  source?: string;
  amplitudeEventHandler?: (eventType: string) => void;
}

const DrawerFooter = styled(Grid)(() => ({
  position: 'fixed',
  bottom: 1,
  background: WsColors.TertiaryShades100,
  width: '50vw',
}));

const ActionFilters = ({
  filterClose = () => {},
  onApplyFilters = () => {},
  source,
  amplitudeEventHandler,
}: ActionFilterPropsFiltersProps) => {
  // const getActionFilterPipeline = actionFilterPipelineStore(
  //   (state) => state.getActionFilterPipeline
  // );

  const methods = useFormContext();
  const workspace = useWorkspaceContext();
  const actionFilters = useStatusActionPipelineContextNew();
  const [recruiterActions, setRecruiterActions] = useState<string[]>(
    methods.getValues('recruiterActions') ?? []
  );
  const [candidateResponse, setCandidateResponse] = useState<string[]>(
    methods.getValues('candidateResponses') ?? []
  );
  const [openActionFilter, setOpenActionFilter] = useState<boolean>(false);
  const onRecruiterActionSelect = (action: string, selected: boolean) => {
    if (selected) {
      setRecruiterActions((oldArray) => [...oldArray, action]);
    } else {
      setRecruiterActions((actions) => actions.filter((value) => value !== action));
    }
  };

  const onCandidateResponseSelect = (action: string, selected: boolean) => {
    if (selected) {
      setCandidateResponse((oldArray) => [...oldArray, action]);
    } else {
      setCandidateResponse((actions) => actions.filter((value) => value !== action));
    }
  };
  const [searchConversation, setSearchConversation] = useState<boolean>(true);
  const onFormSubmit = () => {
    const watchSearchWithMostRecentConversation = methods.watch('searchWithMostRecentConversation');
    const searchIn =
      source == 'Talentpool_Search_Action'
        ? watchSearchWithMostRecentConversation
        : searchConversation;
    const data: ActionFiltersFormProps = {
      candidateResponses: candidateResponse,
      recruiterActions: recruiterActions,
      searchWithMostRecentConversation: searchIn,
    };
    methods.setValue('recruiterActions', recruiterActions);
    methods.setValue('candidateResponses', candidateResponse);
    methods.setValue('searchWithMostRecentConversation', searchIn);
    onApplyFilters(data);
    filterClose();
    setOpenActionFilter(false);
  };
  const handleCheckbox = (e) =>
    e.target.checked ? setSearchConversation(true) : setSearchConversation(false);
  const Reset = () => {
    setRecruiterActions([]);
    setCandidateResponse([]);
  };
  return (
    <ActivateFeature feature="CS_FILTER_BY_RECRUITER_ACTIONS">
      <WsButton
        className="search-by-actions"
        onClick={() => {
          source &&
            amplitude(source, {
              clickedOn: 'Actions',
              pageName: source != 'Talentpool_Search_Action' ? 'PipeLine' : 'TalentPool',
              pageUrl: window.location.href,
              workspaceName: workspace.name,
              planType: workspace.planType,
              interfaceType: 'Web',
            });
          setOpenActionFilter(true);
          if (amplitudeEventHandler) amplitudeEventHandler('action_filter');
        }}
        startIcon={<IoFilterSharp />}
        variant="text"
      >
        Actions
      </WsButton>
      <WsDrawer
        title="Filter by Actions"
        open={openActionFilter}
        onClose={() => {
          filterClose();
          setOpenActionFilter(false);
        }}
        size="medium"
        headerSize="medium"
      >
        <Box component="form" onSubmit={() => onFormSubmit()} mb={10}>
          <Grid container>
            <Grid xs={6}>
              <Box p={1}>
                <WsTypography> Recruiter Action&lsquo;s</WsTypography>
                <BuildActionFilters
                  onSelect={onRecruiterActionSelect}
                  data={actionFilters?.pipelineData.concat(actionFilters?.communicationData)}
                  defaultOptions={recruiterActions}
                ></BuildActionFilters>
              </Box>
            </Grid>
            <Grid xs={6}>
              <Box p={1}>
                <WsTypography> Candidate&lsquo;s Response</WsTypography>
                <BuildActionFilters
                  onSelect={onCandidateResponseSelect}
                  data={actionFilters.resultData}
                  defaultOptions={candidateResponse}
                ></BuildActionFilters>
              </Box>
            </Grid>
          </Grid>
          <DrawerFooter container display="flex" xs={12}>
            <Grid
              justifyContent="flex-start"
              xs={source == 'Talentpool_Search_Action' ? 10 : 6}
              p={1}
            >
              {source == 'Talentpool_Search_Action' ? (
                <WsRadioGroup
                  name="searchWithMostRecentConversation"
                  selectArray={[
                    {
                      label: 'Search in most recent mapping',
                      value: 'true',
                    },
                    {
                      label: 'Searching in the top 5 recent conversations',
                      value: 'false',
                    },
                  ]}
                />
              ) : (
                <FormControlLabel
                  name="searchWithMostRecentConversation"
                  control={
                    <Checkbox checked={searchConversation} onChange={(e) => handleCheckbox(e)} />
                  }
                  label={
                    <WsTypography
                      variant={WsTypoVariants.SUB_TITLE}
                      color={WsTypoColors.BLACK}
                      cursor="pointer"
                    >
                      Search with Most Recent Conversation
                    </WsTypography>
                  }
                />
              )}
            </Grid>
            <Grid justifyContent="flex-end" xs={source == 'Talentpool_Search_Action' ? 2 : 6}>
              <Stack p={1} spacing={2} direction="row" justifyContent="end">
                <WsButton variant="outlined" size="large" onClick={() => Reset()}>
                  Reset
                </WsButton>
                <WsButton variant="contained" size="large" type="submit">
                  Apply
                </WsButton>
              </Stack>
            </Grid>
          </DrawerFooter>
        </Box>
      </WsDrawer>
    </ActivateFeature>
  );
};
export default ActionFilters;

interface BuildActionFilterProps {
  data: candidateInteractionMessagingPipelines[];
  onSelect: (action: string, selected: boolean) => void;
  defaultOptions: string[];
}

const BuildActionFilters = ({ data, onSelect, defaultOptions }: BuildActionFilterProps) => (
  <>
    {data.map((data: candidateInteractionMessagingPipelines, index) => (
      <Box key={index} sx={{ display: 'flex', flexDirection: 'column', m: 0.4 }}>
        <TreeView
          defaultExpanded={[String(index)]}
          aria-label={data.name}
          defaultCollapseIcon={<ExpandMoreIcon />}
          defaultExpandIcon={<ChevronRightIcon />}
          sx={{ flexGrow: 1, overflowY: 'auto' }}
        >
          <TreeItem
            nodeId={String(index)}
            label={
              <FormControlLabel
                label={data.name}
                control={
                  <Checkbox
                    size="small"
                    onChange={(value) => onSelect(data.name, value.target.checked)}
                    checked={defaultOptions.indexOf(data.name) >= 0}
                  />
                }
              />
            }
          >
            {data && data.nodes && data.nodes.length > 0 && (
              <BuildActionFilters
                onSelect={onSelect}
                data={data.nodes}
                defaultOptions={defaultOptions}
              ></BuildActionFilters>
            )}
          </TreeItem>
        </TreeView>
      </Box>
    ))}
  </>
);
